export default class ApiPath {
     static GATEWAYWEB = 'gatewayWeb/';
     static GATEWAYWEB_USER = ApiPath.GATEWAYWEB + 'User/';
     static GATEWAYWEB_USERS = ApiPath.GATEWAYWEB + 'Users/';
     static GATEWAYWEB_DRIVERS = ApiPath.GATEWAYWEB + 'Drivers/';
     static CREATE_USER = ApiPath.GATEWAYWEB_USER + 'CreateUser';
     static GET_ALL_USER = ApiPath.GATEWAYWEB_USERS + 'GetAllUsers';
     static DELETE_USER = ApiPath.GATEWAYWEB_USER + 'DeleteUser';
     static LOGIN = ApiPath.GATEWAYWEB_USER + 'LogIn';
     static FORGET_PASSWORD = ApiPath.GATEWAYWEB_USER + 'ForgetPassword';
     static VERIFY_CODE = ApiPath.GATEWAYWEB_USER + 'VerifyCode'
     static ADD_NEW_PASSWORD = ApiPath.GATEWAYWEB_USER + 'AddNewPassword';
     static GATEWAYWEB_STORE = ApiPath.GATEWAYWEB + 'Store/';
     static CREATE_STORE = ApiPath.GATEWAYWEB_STORE + 'CreateStore';
     static GET_ALL_STORE = ApiPath.GATEWAYWEB_STORE + 'GetAllStore';
     static GATEWAYWEB_ITEMS = ApiPath.GATEWAYWEB + 'Items/';
     static GET_ALL_ITEM = ApiPath.GATEWAYWEB_ITEMS + 'GetAllItem'
     static APPROOVE_ITEM = ApiPath.GATEWAYWEB_ITEMS + 'ApproveItem';
     static TOP_STORE = ApiPath.GATEWAYWEB_STORE + 'TopStore';
     static GATEWAYWEB_ORDERS = ApiPath.GATEWAYWEB + 'Orders/';
     static GET_ALL_ORDERS = ApiPath.GATEWAYWEB_ORDERS + 'GetAllOrdersForAdmin';
     static GET_ORDER_BY_ID = ApiPath.GATEWAYWEB_ORDERS + 'GetOrderByIdForAdmin';
     static GET_ALL_DRIVERS = ApiPath.GATEWAYWEB_DRIVERS + 'GetAllDrivers';
     static CONNECT_DRIVER_WITH_OPERATIONS = ApiPath.GATEWAYWEB_DRIVERS + 'ConnectDriverWithOperations';
     static APPROVAL_DRIVER = ApiPath.GATEWAYWEB_DRIVERS + 'ApprovalDriver';
     static GET_ALL_TOP_DRIVER = ApiPath.GATEWAYWEB_DRIVERS + 'GetAllTopDrivers';
     static GET_ALL_DRIVER_ORDERS = ApiPath.GATEWAYWEB_ORDERS + 'GetAllDriverOrdersForAdmin'
     static UPDATE_PRICE_WITH_PROFIT = ApiPath.GATEWAYWEB_ITEMS + 'UpdatePriceWithProfit';
     static GET_DRIVER_ORDER_BY_ID = ApiPath.GATEWAYWEB_ORDERS + 'GetDriverOrderByIdForAdmin'
     static GET_ALL_CONNECT_DRIVER_WITH_OPERATIONS = ApiPath.GATEWAYWEB + 'ConnectDriverWithOperations/GetAllConnectDriverWithOperations';
     static UN_CONNECT_DRIVER_WITH_OPERATIONS = ApiPath.GATEWAYWEB + 'ConnectDriverWithOperations/UnConnectDriverWithOperations';
     static GET_ALL_PAYMENT_ORDER = ApiPath.GATEWAYWEB_ORDERS + 'GetAllPaymentOrder';
     static PAYMENT_ORDER = ApiPath.GATEWAYWEB_ORDERS + 'PaymentOrder';
     static GATEWAYWEB_NOTIFICATIONS = ApiPath.GATEWAYWEB + 'Notifications/';
     static GET_ALL_NOTIFICATIONS = ApiPath.GATEWAYWEB_NOTIFICATIONS + 'GetAllNotifications';
     static MARK_GET_ALL_NOTIFICATIONS_AS_READ = ApiPath.GATEWAYWEB_NOTIFICATIONS + 'MarkNotificationsAsRead';
     static GATEWAYWEB_CONTACT_US = ApiPath.GATEWAYWEB + 'ContactUs/';
     static GET_ALL_CONTACT_US = ApiPath.GATEWAYWEB_CONTACT_US + 'GetAllContactUs';
     static RESOLVED_CONTACT_US = ApiPath.GATEWAYWEB_CONTACT_US + 'ResolveContactUs';
     static GET_ALL_PENDING_ORDER = ApiPath.GATEWAYWEB_ORDERS + 'GetAllPendingOrdersForAdmin';
     static GET_ALL_ORDERS_FOR_OPERATION = ApiPath.GATEWAYWEB_ORDERS + 'GetAllOrdersForOperation';
     static GET_ALL_DRIVERS_FOR_OPERATION = ApiPath.GATEWAYWEB_DRIVERS + 'GetAllDriversForOperation';
     static GET_TRACKING_DRIVER_FOR_OPERATION = ApiPath.GATEWAYWEB_DRIVERS + 'GetTrackingDriverForOperation';
     static GATEWAYWEB_TERMS_AND_CONDITIONS = ApiPath.GATEWAYWEB + 'TermsAndConditions/';
     static GET_TERMS_AND_CONDITIONS = ApiPath.GATEWAYWEB_TERMS_AND_CONDITIONS + 'GetAllTermsAndConditions';
     static CREATE_TERMS_AND_CONDITIONS = ApiPath.GATEWAYWEB_TERMS_AND_CONDITIONS + 'CreateTermsAndCondition';
     static UPDATE_TERMS_AND_CONDITIONS = ApiPath.GATEWAYWEB_TERMS_AND_CONDITIONS + 'UpdateTermsAndConditions';
     static REORDER_PENDING_ORDERS = ApiPath.GATEWAYWEB_ORDERS + 'ReorderPendingOrdersForAdmin';
     static LOCATION = ApiPath.GATEWAYWEB +'Location'
     static BLOCK = ApiPath.GATEWAYWEB_DRIVERS + 'block';
     static BAN = ApiPath.GATEWAYWEB_DRIVERS + 'ban';
     static GATEWAYWEB_SETTINGS = ApiPath.GATEWAYWEB + 'settings/';
     static DELIVERY_COMMISSION_PERCE= ApiPath.GATEWAYWEB_SETTINGS + 'delivery_commission_percentage'


     
     
}